import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spin, Result, Button } from 'antd';
import axios from '../api';

const OAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const error = params.get('error');

    if (error) {
      setStatus('error');
      setMessage('授权被拒绝或发生错误');
      return;
    }

    if (code) {
      // 发送 code 到后端换取 token
      axios.post('/api/google-oauth-callback/', {
        code,
        account_name: 'Google账号'
      })
      .then(res => {
        setStatus('success');
        setMessage('Google账号授权成功！');
        // 3秒后跳转到云文档同步页面
        setTimeout(() => {
          navigate('/cloud-sync');
        }, 3000);
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.error || '授权失败，请重试');
      });
    } else {
      setStatus('error');
      setMessage('未获取到授权码');
    }
  }, [location, navigate]);

  if (status === 'loading') {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column'
      }}>
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>正在处理授权...</div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <Result
        status="success"
        title="授权成功"
        subTitle={message}
        extra={[
          <Button type="primary" key="go" onClick={() => navigate('/cloud-sync')}>
            前往云文档同步
          </Button>,
          <Button key="home" onClick={() => navigate('/')}>
            返回首页
          </Button>
        ]}
      />
    );
  }

  return (
    <Result
      status="error"
      title="授权失败"
      subTitle={message}
      extra={[
        <Button type="primary" key="retry" onClick={() => window.location.reload()}>
          重试
        </Button>,
        <Button key="back" onClick={() => navigate('/cloud-sync')}>
          返回云文档同步
        </Button>
      ]}
    />
  );
};

export default OAuthCallback; 